import { Box, Button, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../utility/Loader';
import ViemoPlayerWithMarker from "../../../components/EntertainmentEntityManagement/CreateUpdateMultimediaAndQuesEE/ViemoPlayerWithMarker";
import { getMediaDimensionsAndRatio, updateStateObjectData } from "../../../utility/Common";
import { GameCssStyles } from "../../../components/GameManagement/GameCssStyles";
import { extractVimeoId, getVimeoPlayLink, getVimeoPlayLink2, setOnProgressCallback, uploadVideoToVimeo } from "../../../network/vimeo_network_service/Vimeo_api_callback";
import { extractCloudflareStreamId, getCloudflareStreamWatchUrl, resolveVideoPreview } from "../../../network/cloudflare_stream_service/CloudflareStream_api_callback";
import VimeoVideoPlayer from "../../../components/EntertainmentEntityManagement/CreateUpdateMultimediaAndQuesEE/VimeoVideoPlayer";
import VideoPlayerWithMarker from "./VideoPlayerWithMarker";
import ProgressModal from "../../../utility/ProgressModal";
import { VIMEO_BUCKETS } from "../../../network/vimeo_network_service/Vimeo_Constant";
import api_service from "../../../network/api_callbacks";
import { toast } from "react-toastify";

const dummyObj = {
    "id": "12",
    "title": "title",
    "image": "https://i.vimeocdn.com/video/2043088526-90587b51110f8369cafa26681537be8e2ff3ab36788aa7e35040d37e9b6dc150-d?region=us",
    "duration": 120000,
    "theme": "ratro",
    "videoUrl": "https://api.vimeo.com/videos/1106363236",
    "timeLine": [
        {
            "time": "0",
            "entityId": "689ada272293818b449a544b",
            "multimediaId": "689adae92293818b449a5457"
        },
        {
            "time": "20000",
            "entityId": "689ae38c2293818b449a54b4",
            "multimediaId": "689ae4182293818b449a54be"
        }
    ]
}

const RapHousiCreateMultimedia = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const state = location.state;
    const [loader, setLoader] = useState(false);

    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);

    const [multimediaDetail, setMultimediaDetail] = useState(null);

    // New states
    const [inputMode, setInputMode] = useState("vimeo"); // "vimeo" | "upload"
    const [vimeoId, setVimeoId] = useState("");
    const [uploadFile, setUploadFile] = useState(null);

    useEffect(() => {
        const loadVideo = async () => {
            try {
                if (multimediaDetail === null && state?.multimediaDetail) {
                    getMultimediaDetail(state?.multimediaDetail?._id);
                }
            } catch (err) {
                console.error("❌ Error fetching Vimeo link:", err);
            }
        };
        loadVideo();
    }, [multimediaDetail, state]);

    const applyCloudflarePreview = (detail, cfId) => {
        const preview = resolveVideoPreview({
            form: 'video',
            cloudFlareVideoId: cfId,
            url: detail?.videoUrl,
        });
        setVimeoId(preview.id || cfId);
        setInputMode('cloudflare');
        setMultimediaDetail({
            ...detail,
            cloudFlareVideoId: preview.id || cfId,
            videoUrl: detail?.videoUrl || getCloudflareStreamWatchUrl(preview.id || cfId),
            progressiveLink: preview.embedUrl,
            playerType: 'cloudflare',
        });
    };

    const getMultimediaDetail = async (id) => {
        setLoader(true);
        try {
            const response = await api_service.getTambolaMultimediaDetail({ id: id });
            // Merge list-row state so cloudFlareVideoId is not lost if API omits it
            const responseData = {
                ...(state?.multimediaDetail || {}),
                ...(response || {}),
            };

            console.log('📘 response :', responseData);

            const preview = resolveVideoPreview({
                form: 'video',
                url: responseData?.videoUrl,
                cloudFlareVideoId: responseData?.cloudFlareVideoId,
            });

            if (preview.type === 'cloudflare' && preview.id) {
                applyCloudflarePreview(responseData, preview.id);
                return;
            }

            const resolvedVimeoId = extractVimeoId(responseData?.videoUrl);
            if (!resolvedVimeoId) {
                // Last resort: treat bare non-http videoUrl / id field as Cloudflare
                const fallbackCf = extractCloudflareStreamId(responseData?.videoUrl)
                    || extractCloudflareStreamId(responseData?.cloudFlareVideoId);
                if (fallbackCf) {
                    applyCloudflarePreview(responseData, fallbackCf);
                    return;
                }
                setMultimediaDetail({ ...responseData, playerType: 'unknown' });
                return;
            }

            setVimeoId(resolvedVimeoId);
            setInputMode('vimeo');
            const { progressiveLink, playLink } = await getVimeoPlayLink(resolvedVimeoId);
            setMultimediaDetail({
                ...responseData,
                vimeoId: `${resolvedVimeoId}`,
                progressiveLink: progressiveLink || playLink,
                playerType: 'vimeo',
            });
        } catch (error) {
            console.error('❌ Failed to fetch getMultimediaDetail:', error);
        }
        finally {
            setLoader(false);
        }
    }

    const handleBackToHousieMultimediaManagement = () => {
        const path = location?.pathname;
        const cleanedPath = path.substring(0, path.lastIndexOf("/"));
        navigate(`${cleanedPath}`, {
            state: { shouldRefresh: true }
        });
    };

    const createMultimedia = async () => {
        setLoader(true);
        try {
            console.log("multimediaDetail : ", multimediaDetail)

            // Clean multimediaDetail before sending
            const cleanedMultimedia = {
                ...multimediaDetail,
                // remove progressiveLink
                progressiveLink: undefined,
                // clean timeLine by removing "details"
                // clean timeLine by removing "details" and converting time -> string
                timeLine: multimediaDetail?.timeLineV2?.map(({ details, _id, ...rest }) => ({
                    //...rest,
                    time: String(rest.time), // convert to string
                    entityId: `${rest.entityId || rest.entityID}`,
                    multimediaId: `${rest.multimediaId}`,
                })) || []
            };

            delete cleanedMultimedia.title;
            delete cleanedMultimedia.image;
            delete cleanedMultimedia.timeLineV2;
            delete cleanedMultimedia.progressiveLink;
            delete cleanedMultimedia.created_at;
            delete cleanedMultimedia.updated_at;
            delete cleanedMultimedia.vimeoId;
            delete cleanedMultimedia.playerType;
            delete cleanedMultimedia.__v;
            delete cleanedMultimedia._id;

            // Build request object
            const request = {
                ...cleanedMultimedia
            };

            const response = await api_service.addTambolaMultimedia(request);
            console.log('📘 response :', response);
            toast.success(`Multimedia created successfully.`)
            setLoader(false);
            handleBackToHousieMultimediaManagement();
        } catch (error) {
            console.error('❌ Failed to fetch createMultimedia:', error);
        }
    }

    const updateMultimedia = async () => {
        setLoader(true);
        try {
            console.log("multimediaDetail : ", multimediaDetail)

            // Clean multimediaDetail before sending
            const cleanedMultimedia = {
                ...multimediaDetail,
                // remove progressiveLink
                progressiveLink: undefined,
                // clean timeLine by removing "details"
                // clean timeLine by removing "details" and converting time -> string
                timeLine: multimediaDetail?.timeLineV2?.map(({ details, _id, ...rest }) => ({
                    //...rest,
                    time: String(rest.time), // convert to string
                    entityId: `${rest.entityId || rest.entityID}`,
                    multimediaId: `${rest.multimediaId}`,
                })) || []
            };

            delete cleanedMultimedia.title;
            delete cleanedMultimedia.image;
            delete cleanedMultimedia.timeLineV2;
            delete cleanedMultimedia.progressiveLink;
            delete cleanedMultimedia.created_at;
            delete cleanedMultimedia.updated_at;
            delete cleanedMultimedia.vimeoId;
            delete cleanedMultimedia.playerType;
            delete cleanedMultimedia.__v;
            delete cleanedMultimedia._id;
            delete cleanedMultimedia.isDeleted;
            delete cleanedMultimedia.status;

            // Build request object
            const request = {
                ...cleanedMultimedia
            };

            const response = await api_service.editTambolaMultimedia({ data: request, id: multimediaDetail?._id });
            console.log('📘 response :', response);
            toast.success(`Multimedia updated successfully.`)
            setLoader(false);
            handleBackToHousieMultimediaManagement();
        } catch (error) {
            console.error('❌ Failed to fetch updateMultimedia:', error);
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadFile(file);
            uploadFileOnVimeo(e, file);
        }
    };

    const uploadFileOnVimeo = async (e, file) => {
        try {
            setUploading(true);
            setProgress(0);
            setOnProgressCallback((percent) => setProgress(percent));
            const { width, height, mediaType, ratio } = await getMediaDimensionsAndRatio(file);
            const resp = await uploadVideoToVimeo(file, VIMEO_BUCKETS.VIMEO_BUCKET_ENTITY_VIDEOS_STAGING, mediaType);
            console.log("VIMEO 1 : ", resp)
            const lastSegment = resp?.videoUri;
            const finalUrl = "https://api.vimeo.com" + lastSegment;
            console.log("VIMEO 2 : ", finalUrl)
            const vimeoId = extractVimeoId(finalUrl);
            console.log("vimeoId : ", vimeoId)
            const videoInfo = await getVimeoPlayLink2(vimeoId);

            if (!videoInfo) {
                console.error(`No playable Vimeo link found for video ID: ${vimeoId}`);
                return; // or show error to user
            }

            const { progressiveLink, playLink, videoData } = videoInfo;

            //setVideoSrc(progressiveLink || playLink);
            console.log("progressiveLink : ", progressiveLink)

            const title = videoData?.name;
            const duration = videoData?.duration;
            const image = videoData?.pictures?.base_link;
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "title", `${title}`);
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "duration", `${duration}`);
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "image", `${image}`);
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "vimeoId", `${vimeoId}`);
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "progressiveLink", progressiveLink);
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "videoUrl", `https://api.vimeo.com/videos/${vimeoId}`);
            updateStateObjectData(multimediaDetail, setMultimediaDetail, "timeLine", []);

            e.target.value = null; // reset input
        } catch (err) {
            console.error("❌ Error fetching Vimeo link:", err);
            setUploading(false)
        }
        finally {
            setUploading(false)
        }
    }

    const handleSave = async () => {
        const rawId = String(vimeoId || "").trim();
        if (!rawId && inputMode !== "upload") {
            toast.error("Enter a Vimeo or Cloudflare video ID");
            return;
        }

        // Detect provider: Cloudflare Stream IDs are 32-hex (or CF URLs); Vimeo IDs are numeric
        const cfId = extractCloudflareStreamId(rawId);
        const looksLikeVimeo = Boolean(extractVimeoId(rawId)) || /^[0-9]+$/.test(rawId);

        if (cfId && !looksLikeVimeo) {
            console.log("Saving Cloudflare Video ID:", cfId);
            const base = multimediaDetail || {
                title: "",
                image: "",
                duration: 0,
                theme: "",
                timeLine: [],
                timeLineV2: [],
            };
            applyCloudflarePreview(base, cfId);
            toast.success("Cloudflare video preview ready");
            return;
        }

        if (inputMode === "upload" && uploadFile) {
            console.log("Uploading file:", uploadFile);
            return;
        }

        console.log("Saving Vimeo ID:", rawId);
        const videoInfo = await getVimeoPlayLink(rawId);

        if (!videoInfo) {
            // If Vimeo failed, retry as Cloudflare when ID looks like a stream id
            if (cfId) {
                applyCloudflarePreview(multimediaDetail || {}, cfId);
                toast.success("Cloudflare video preview ready");
                return;
            }
            console.error(`No playable Vimeo link found for video ID: ${rawId}`);
            toast.error("Could not load video. Check Vimeo/Cloudflare ID.");
            return;
        }

        const { progressiveLink, playLink, videoData } = videoInfo;
        const title = videoData?.name;
        const duration = videoData?.duration;
        const image = videoData?.pictures?.base_link;
        setInputMode("vimeo");
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "title", `${title}`);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "duration", `${duration}`);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "image", `${image}`);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "vimeoId", `${rawId}`);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "progressiveLink", progressiveLink || playLink);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "videoUrl", `https://api.vimeo.com/videos/${rawId}`);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "playerType", "vimeo");
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "cloudFlareVideoId", null);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "timeLine", []);
        updateStateObjectData(multimediaDetail, setMultimediaDetail, "timeLineV2", []);
    };

    // Removed global scroll disabling to allow marker list to scroll

    return (
        <>
            <Box sx={{
                flex: 1,
                height: '100%',
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                padding: 0,
                gap: 0,
                marginBottom: 0,
                position: "relative"
            }}>

                {/* Header Section */}
                <Box sx={{
                    flexShrink: 0,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 0,
                    padding: 0,
                    position: "sticky",   // ✅ stick within parent container
                    top: 0,               // ✅ stick to the top
                    zIndex: 5,            // ✅ ensure it stays above content
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd", // optional for visual separation
                }}>

                    <Box sx={{
                        backgroundColor: '#f4f1f9',
                        justifyContent: 'flex-start',
                        borderRadius: 1,
                        border: '1px solid #000000',
                        padding: 4,
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        gap: 2,
                        m: 0,
                        height: "100%",
                        alignItems: "center",
                    }}>

                        <Box sx={{
                            flex: 0, width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignContent: "center"
                        }}>

                            {/* <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Select Video Source</Typography> */}
                            <Typography variant="h5" sx={{ mt: 0, fontWeight: 700, textAlign: 'end' }}>{multimediaDetail?.title ? multimediaDetail?.title : "Create Multimedia"}</Typography>

                            <Button
                                variant="contained"
                                color="error"
                                fullWidth={false}
                                sx={{ height: 50, width: 200, backgroundColor: "#a855f7", color: 'white', fontSize: 16 }}
                                onClick={() => {
                                    multimediaDetail?._id ? updateMultimedia() : createMultimedia()
                                }}
                                disabled={!vimeoId && !multimediaDetail?.cloudFlareVideoId}
                            >{multimediaDetail?._id ? "update" : "create"}</Button>
                        </Box>

                        <Box sx={{
                            flex: 0, width: '100%', flexDirection: 'column', display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignContent: "center"
                        }}>
                            {/* <ToggleButtonGroup
                            color="primary"
                            value={inputMode}
                            exclusive
                            onChange={(e, newMode) => newMode && setInputMode(newMode)}
                            sx={{ mb: 2, background: "#f9f9f9" }}
                        >
                            <ToggleButton value="vimeo" sx={{
                                color: "black", // default text color
                                "&.Mui-selected": {
                                    color: "white", // text color when selected
                                    backgroundColor: "#1976d2", // optional: change bg when selected
                                    "&:hover": {
                                        backgroundColor: "#1565c0"
                                    }
                                }
                            }}>Add Vimeo Video ID</ToggleButton>
                            <ToggleButton value="upload" sx={{
                                color: "black", // default text color
                                "&.Mui-selected": {
                                    color: "white", // text color when selected
                                    backgroundColor: "#1976d2", // optional: change bg when selected
                                    "&:hover": {
                                        backgroundColor: "#1565c0"
                                    }
                                }
                            }}>Upload Multimedia</ToggleButton>
                        </ToggleButtonGroup> */}

                            {(inputMode === "vimeo" || inputMode === "cloudflare") && (
                                <TextField
                                    fullWidth
                                    label={inputMode === "cloudflare" ? "Cloudflare Video ID" : "Vimeo / Cloudflare Video ID"}
                                    value={vimeoId}
                                    onChange={(e) => setVimeoId(e.target.value)}
                                    helperText={inputMode === "cloudflare" ? "Detected: Cloudflare Stream" : "Paste Vimeo numeric ID or Cloudflare Stream ID"}
                                    sx={[{ ...GameCssStyles.formSingleLineTextField_sx }, { mt: 2 }]}
                                />
                            )}

                            {inputMode === "upload" && (
                                <Button
                                    variant="contained"
                                    component="label"
                                    sx={{ textTransform: "none", alignSelf: "center" }}
                                >
                                    {uploadFile ? uploadFile.name : "Choose Video File"}
                                    <input
                                        hidden
                                        type="file"
                                        accept="video/*"
                                        onChange={handleFileChange}
                                    />
                                </Button>
                            )}

                            <Button
                                variant="contained"
                                color="success"
                                sx={{ mt: 2, alignSelf: "flex-end" }}
                                onClick={handleSave}
                            >
                                Save & Preview Video
                            </Button>

                            <TextField
                                fullWidth
                                label="Theme"
                                multiline={false}
                                rows={1}
                                value={multimediaDetail?.theme || 'Theme'}
                                onChange={(e) => { updateStateObjectData(multimediaDetail, setMultimediaDetail, 'theme', e.target.value) }}
                                sx={[{ ...GameCssStyles.formSingleLineTextField_sx }, { marginTop: 2 }]}
                            />
                        </Box>
                    </Box>

                    {/* <Button
                        variant="contained"
                        color="error"
                        sx={{ borderRadius: 2, textTransform: "none", mr: 0, height: 40, width: 'auto' }}
                        onClick={() => {
                            //onCreateClick();
                        }}
                    >
                        Remove Multimedia
                    </Button> */}
                </Box>

                {/* Video Player Section */}
                <Box sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    display: "flex",
                    padding: 0,
                    flexDirection: "column",
                    gap: 0,
                    marginBottom: 0,
                    position: "relative",
                    overflowY: "auto",
                    backgroundColor: "#fff",
                }}>

                    {/* Toggle between Vimeo ID and Upload */}
                    {/* <Box sx={styles.containerStyleRow_sx}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Select Video Source</Typography>
                        <ToggleButtonGroup
                            color="primary"
                            value={inputMode}
                            exclusive
                            onChange={(e, newMode) => newMode && setInputMode(newMode)}
                            sx={{ mb: 2, background: "#f9f9f9" }}
                        >
                            <ToggleButton value="vimeo" sx={{
                                color: "black", // default text color
                                "&.Mui-selected": {
                                    color: "white", // text color when selected
                                    backgroundColor: "#1976d2", // optional: change bg when selected
                                    "&:hover": {
                                        backgroundColor: "#1565c0"
                                    }
                                }
                            }}>Add Vimeo Video ID</ToggleButton>
                            <ToggleButton value="upload" sx={{
                                color: "black", // default text color
                                "&.Mui-selected": {
                                    color: "white", // text color when selected
                                    backgroundColor: "#1976d2", // optional: change bg when selected
                                    "&:hover": {
                                        backgroundColor: "#1565c0"
                                    }
                                }
                            }}>Upload Multimedia</ToggleButton>
                        </ToggleButtonGroup>

                        {(inputMode === "vimeo" || inputMode === "cloudflare") && (
                            <TextField
                                fullWidth
                                label={inputMode === "cloudflare" ? "Cloudflare Video ID" : "Enter Vimeo Video ID"}
                                value={vimeoId}
                                onChange={(e) => setVimeoId(e.target.value)}
                                sx={GameCssStyles.formSingleLineTextField_sx}
                                InputProps={{ readOnly: inputMode === "cloudflare" }}
                            />
                        )}

                        {inputMode === "upload" && (
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ textTransform: "none", alignSelf: "center" }}
                            >
                                {uploadFile ? uploadFile.name : "Choose Video File"}
                                <input
                                    hidden
                                    type="file"
                                    accept="video/*"
                                    onChange={handleFileChange}
                                />
                            </Button>
                        )}

                        <Button
                            variant="contained"
                            color="success"
                            sx={{ mt: 2, alignSelf: "flex-end" }}
                            onClick={handleSave}
                        >
                            Save & Preview Video
                        </Button>
                    </Box> */}

                    <Box sx={{ flex: 1, minHeight: 0, p: 2, display: "flex", width: '100%', justifyContent: "center", alignItems: "flex-start" }}>
                        <VideoPlayerWithMarker multimediaDetail={multimediaDetail} setMultimediaDetail={setMultimediaDetail} />
                    </Box>
                </Box>

            </Box>
            {/* {(loader) && <Loader />} */}
            {(uploading || loader) && <ProgressModal open={uploading || loader} isLoader={loader} progress={progress} title="Uploading File" />}
        </>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'flex-start',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 4,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4,
        height: "100%",
        alignItems: "center",
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(RapHousiCreateMultimedia)